module.exports = __webpack_public_path__ + "img/SKLB-Pagos.de0e6847.png";